/** @description always include jQuery in this manner in every file where jQuery is used */

import Global from './global';

const $ = jQuery.noConflict();

'use strict';
const Invoice = {

	OrderId: null,
	InvoiceId: null,

	// initialize
	init: function() {

		// grab current invoice-id (opening fancybox happens elsewhere)
		$('body').on('click', '.js-order-popup-btn', function() {
			Invoice.OrderId = $(this).closest('.invoices-table').data('order-id');
			Invoice.InvoiceId = $(this).closest('.invoice-row').data('invoice-id');
			Invoice.PopulateForm();
		});
	},

	// fill DOM with data
	PopulateForm() {
		// select data
		const Data = window.InvoicesTable[Invoice.InvoiceId];

		// populate simple fields
		$('.js-invoice-num').text(Data.Name);
		$('.js-invoice-date').text(Data.Date);
		$('.js-invoice-status').text(Data.status)
		.toggleClass('color-theme-green', Data.status === 'paid')
		.toggleClass('color-red', Data.status !== 'paid');
		$('.js-invoice-total').text('$' + Data.amount);

		// update "download" button link
		$('.js-invoice-download').attr('href', '/invoice/?id=' + Invoice.OrderId + '&invoice=' + Invoice.InvoiceId);

		// populate table
		$('.js-order-popup table tbody tr').remove();
		let Rows = '';
		let Shipping = '';
		Data.products.forEach(v => {
			if (v.isShipping) {
				Shipping = '<tr><td colspan="3">Shipping</td><td>$' + v.price + '</td></tr>';
			} else {
				Rows += '<tr><td><img src="' + v.img + '"></td><td>' + v.name + '</td><td>x' + v.qty + '</td><td>$' + v.price + '</td></tr>';
			}
		});
		$('.js-order-popup table tbody').append($(Rows + Shipping));
	},

};

export default Invoice;
